import { XCircle } from "lucide-react";

const pains = [
  "Rileggi la stessa pagina tre volte e alla fine non ricordi nulla.",
  "Passi ore sui libri, ma all'interrogazione la mente si svuota.",
  "Ti sembra di aver capito… finché non devi spiegarlo con parole tue.",
  "L'ansia da esame trasforma lo studio in una corsa contro il tempo.",
];

export default function Struggle() {
  return (
    <section className="relative py-16 sm:py-24 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="relative order-2 lg:order-1">
          <div className="absolute inset-0 bg-[#f0d203]/20 rounded-[2.5rem] -rotate-3" />
          <img
            src="https://images.pexels.com/photos/6958567/pexels-photo-6958567.jpeg"
            alt="Studente stressato sui libri"
            className="relative w-full h-[440px] object-cover rounded-[2rem] shadow-[0_20px_40px_rgb(0,0,0,0.08)]"
          />
        </div>

        <div className="order-1 lg:order-2">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#5982c5]">Ti capiamo</span>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#1f2937]">
            Ti senti frustrato davanti ai libri?
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-[#4b5563]">
            Non sei tu il problema, e non è questione di talento. Il vero problema è il <em>modo</em> in cui
            studi. Rileggere e ripetere danno solo l'illusione di aver capito: è la “falsa comprensione”.
          </p>

          <ul className="mt-8 space-y-4">
            {pains.map((p, i) => (
              <li key={i} className="flex items-start gap-3 bg-white rounded-2xl p-4 border border-[#e5e7eb] shadow-[0_8px_30px_rgb(0,0,0,0.03)]">
                <XCircle size={22} className="text-[#5982c5] shrink-0 mt-0.5" />
                <span className="text-[#4b5563] leading-relaxed">{p}</span>
              </li>
            ))}
          </ul>

          <p className="mt-8 font-heading text-xl font-semibold text-[#1f2937]">
            E se il problema non fosse quanto studi, ma <span className="text-[#5982c5]">come</span> lo fai?
          </p>
        </div>
      </div>
    </section>
  );
}
